export default "__VITE_ASSET__BrNE6sSh__"